






















































































































import {
  defineComponent,
  ref,
  ssrRef,
  useFetch,
} from '@nuxtjs/composition-api';
import { SfHeading, SfSelect } from '@storefront-ui/vue';
// import { useCache } from '@vue-storefront/cache';
import LazyHydrate from 'vue-lazy-hydration';

import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import {
  useCategoryPageInfo,
  useFacet,
  useUiHelpers,
  useUiState,
} from '~/composables';
import type { Pagination } from '~/composables/types';
import { useAddToCart } from '~/helpers/cart/addToCart';
import { getMetaInfo } from '~/helpers/getMetaInfo';
import { useI18n } from '~/helpers/hooks/usei18n';
import CategoryBreadcrumbs from '~/modules/catalog/category/components/breadcrumbs/CategoryBreadcrumbs.vue';
import CategorySubChildren from '~/modules/catalog/category/components/children/CategorySubChildren.vue';
// import { useCategoryContent } from '~/modules/catalog/category/components/cms/useCategoryContent';
import CategoryNavbar from '~/modules/catalog/category/components/navbar/CategoryNavbar.vue';
import CategoryPagination from '~/modules/catalog/category/components/pagination/CategoryPagination.vue';
import { useCategorySearch } from '~/modules/catalog/category/composables/useCategorySearch';
import type { SortingModel } from '~/modules/catalog/category/composables/useFacet/sortingOptions';
import facetGetters from '~/modules/catalog/category/getters/facetGetters';
import type { Product } from '~/modules/catalog/product/types';
import type { ProductInterface } from '~/modules/GraphQL/types';
import { CategoryTree } from '~/modules/GraphQL/types';
import { useWishlist } from '~/modules/wishlist/composables/useWishlist';
import { usePageStore } from '~/stores/page';

export default defineComponent({
  name: 'CategoryPage',
  components: {
    CategoryPagination,
    CategoryEmptyResults: () =>
      import('~/modules/catalog/category/components/CategoryEmptyResults.vue'),
    CategoryFilters: () =>
      import(
        '~/modules/catalog/category/components/filters/CategoryFilters.vue'
      ),
    CmsContent: () =>
      import('~/modules/catalog/category/components/cms/CmsContent.vue'),
    CategoryProductGrid: () =>
      import(
        '~/modules/catalog/category/components/views/CategoryProductGrid.vue'
      ),
    // eslint-disable-next-line vue/no-unused-components
    CategoryProductList: () =>
      import(
        '~/modules/catalog/category/components/views/CategoryProductList.vue'
      ),
    CategoryNavbar,
    CategoryBreadcrumbs,
    CategorySubChildren,
    SfSelect,
    LazyHydrate,
    SfHeading,
    SkeletonLoader,
  },
  transition: 'fade',
  setup() {
    const { routeData } = usePageStore();
    // const { getContentData } = useCategoryContent();
    const { loadCategoryMeta } = useCategoryPageInfo();

    // const { addTags } = useCache();
    const uiHelpers = useUiHelpers();
    const cmsContent = ref('');
    const isShowCms = ref(false);
    const isShowProducts = ref(false);
    const products = ssrRef<ProductInterface[]>([]);
    const sortBy = ref<SortingModel>({ selected: '', options: [] });
    const pagination = ref<Pagination>({});
    const aggregations = ref<any>([]);
    const { locale } = useI18n();

    const categories = ref({});
    const productContainerElement = ref<HTMLElement | null>(null);

    const {
      toggleFilterSidebar,
      changeToCategoryListView,
      changeToCategoryGridView,
      isCategoryGridView,
      isFilterSidebarOpen,
    } = useUiState();
    const {
      addItem: addItemToWishlistBase,
      isInWishlist,
      removeItem: removeItemFromWishlist,
    } = useWishlist();
    const { result, search } = useFacet();

    const { addItemToCart } = useAddToCart();

    const categoryMeta = ref(null);
    const subcategories = ref<CategoryTree[]>([]);

    const { search: searchCategories, loading: categoriesLoad } =
      useCategorySearch();

    const addItemToWishlist = async (product: Product) => {
      await (isInWishlist({ product })
        ? removeItemFromWishlist({ product })
        : addItemToWishlistBase({ product }));
    };

    // const { activeCategory, loadCategoryTree } = useTraverseCategory();
    // const activeCategoryName = computed(() => activeCategory.value?.name ?? '');

    const categoryUid = routeData.uid;

    useFetch(async () => {
      const response: any = await loadCategoryMeta({
        category_uid: categoryUid,
      });
      categoryMeta.value = response?.categoryMeta;
      cmsContent.value = response?.cmsBlock?.content ?? '';
      isShowCms.value = response?.isShowCms;
      isShowProducts.value = response?.isShowProducts;

      categories.value = response?.categoryList[0];

      subcategories.value = response?.categoryList[0]?.children?.filter(
        (item: CategoryTree) => item.include_in_menu === 1
      );
    });

    const { fetch } = useFetch(async () => {
      // ** top banner data
      // const categoriesData = await searchCategories({
      //   filters: {
      //     category_uid: {
      //       eq: categoryUid,
      //     },
      //   },
      //   customQuery: {
      //     categorySearch: 'category-search-custom-query',
      //   },
      // });
      // // eslint-disable-next-line prefer-destructuring
      // categories.value = categoriesData[0];
      // subcategories.value = categoriesData[0]?.children?.filter(
      //   (item: CategoryTree) => item.include_in_menu === 1
      // );

      await Promise.all([
        search({ ...uiHelpers.getFacetsFromURL(), category_uid: categoryUid }),
      ]);

      // const [content] = await Promise.all([
      //   getContentData(categoryUid as string), // get banner config
      //   search({ ...uiHelpers.getFacetsFromURL(), category_uid: categoryUid }),
      // ]);

      // cmsContent.value = content?.cmsBlock?.content ?? '';
      // isShowCms.value = content.isShowCms;
      // isShowProducts.value = content.isShowProducts;

      products.value = facetGetters.getProducts(result.value) ?? [];
      sortBy.value = facetGetters.getSortOptions(result.value, locale);
      pagination.value = facetGetters.getPagination(result.value);
      aggregations.value = facetGetters.getAggregation(result.value) ?? [];
      // const tags = [{ prefix: CacheTagPrefix.View, value: routeData.uid }];
      // const productTags = products.value.map((product) => ({
      //   prefix: CacheTagPrefix.Product,
      //   value: product.uid,
      // }));

      // addTags([...tags, ...productTags]);
    });
    console.log('products list', products);

    const isPriceLoaded = ref(true);

    const goToPage = (page: number) => {
      uiHelpers.changePage(page, false);
      fetch();
    };

    const doChangeItemsPerPage = (itemsPerPage: number) => {
      uiHelpers.changeItemsPerPage(itemsPerPage, false);
      goToPage(0);
    };

    const onReloadProducts = () => {
      goToPage(0);
      productContainerElement.value.scrollIntoView();
    };

    return {
      isPriceLoaded,
      ...uiHelpers,
      toggleFilterSidebar,
      isCategoryGridView,
      changeToCategoryListView,
      changeToCategoryGridView,
      isFilterSidebarOpen,
      addItemToCart,
      addItemToWishlist,
      pagination,
      aggregations,
      products,
      sortBy,
      isShowCms,
      isShowProducts,
      cmsContent,
      routeData,
      doChangeItemsPerPage,
      productContainerElement,
      categoryMeta,
      onReloadProducts,
      goToPage,
      categories,
      categoriesLoad,
      subcategories,
    };
  },
  head() {
    return getMetaInfo(this.categoryMeta);
  },
});
